import type { ReactElement } from "react";
interface UploadProgress {
  bytesUploaded: number;
  totalBytes: number;
  percentage: number;
}

interface VideoUploadProgressProps {
  progress: UploadProgress;
  formatBytes: (bytes: number) => string;
}

/**
 * Video Upload Progress Component
 */
export function VideoUploadProgress({ progress, formatBytes }: Readonly<VideoUploadProgressProps>): ReactElement {
  return (
    <div className="bg-neutral-900 border border-lumi-accent rounded-lg p-4">
      <div className="mb-2 flex items-center justify-between text-sm">
        <span className="text-white font-medium">Uploading...</span>
        <span className="text-lumi-accent">{progress.percentage.toFixed(1)}%</span>
      </div>
      <div className="w-full bg-neutral-800 rounded-full h-2 mb-2">
        <div
          className="bg-lumi-accent h-2 rounded-full transition-all duration-300"
          style={{ width: `${progress.percentage}%` }}
        />
      </div>
      <div className="flex justify-between text-xs text-neutral-400">
        <span>{formatBytes(progress.bytesUploaded)}</span>
        <span>{formatBytes(progress.totalBytes)}</span>
      </div>
    </div>
  );
}
